import React, { useEffect, useState } from "react";
import Logo from "../assets/logo/LogoKingN.svg";

import Social from "./Social";
import { BlockchainService } from '../services/blockchainService';
import { SNAPSHOTS_URL, snapshotUrlFor, useSnapshotNetworks } from '../services/snapshotNetworks';
import type { HygraphBlockchain } from '../types';

export default function Footer() {
    const [blockchains, setBlockchains] = useState<HygraphBlockchain[]>([]);
    const snapshotNetworks = useSnapshotNetworks();

    useEffect(() => {
        async function loadBlockchains() {
            try {
                const data = await BlockchainService.getAllBlockchains();
                setBlockchains(data);
            } catch (err) {
                console.error('Failed to load blockchains for footer:', err);
            }
        }
        loadBlockchains();
    }, []);

    return (
        <div className="footer w-full">
            <div className="flex flex-col lg:flex-row pb-0 lg:pb-10">
                <div className="flex flex-1 flex-col justify-start pb-10">
                    <a
                        href="/"
                        className="lg:pb-10 pb-5 justify-start flex"
                    >
                        <img className="logo" src={Logo} alt='Kingnodes' />
                    </a>
                    <p className="text-left text text-logo">
                        Earn staking rewards on your crypto assets with conﬁdence
                        <br />
                        <br />
                        <a className="footer-link" href="mailto:hello@kingnodes.com">hello@kingnodes.com</a>
                        <br />
                        <br />
                        <a className="text-link" href={SNAPSHOTS_URL}>Node snapshots, seeds and peers</a>
                    </p>
                </div>
                <div className="flex flex-1 flex-col justify-start pb-10">
                    <p className="text-left title px-0 lg:px-10 lg:pb-10">
                        Live Networks
                    </p>
                    <div className="grid grid-cols-2 w-full">
                        {blockchains.map(blockchain => {
                            const snapshotsUrl = snapshotUrlFor(snapshotNetworks, blockchain.blockchainName);
                            return (
                                <span key={blockchain.id} className="text-left text2 px-0 lg:px-10 py-2">
                                    {snapshotsUrl ? (
                                        <a className="footer-link" href={snapshotsUrl} title={`${blockchain.blockchainName} node snapshots`}>
                                            {blockchain.blockchainName}
                                        </a>
                                    ) : (
                                        blockchain.blockchainName
                                    )}
                                </span>
                            );
                        })}
                    </div>
                </div>

            </div>
            <div className="flex flex-col-reverse lg:flex-row justify-between pt-0 lg:pt-10 items-center">
                <p className="text-center lg:text-left bottom-title">
                    © Kingnodes {new Date().getFullYear()}
                </p>
                <div className='flex flex-1 nav-links pb-8 lg:pb-0'>
                    <Social />
                </div>
            </div>
        </div>
    );
}

